<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('reactions')">Reaction</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="reaction.deleted_at" class="mb-6" @restore="restore">
      This reaction has been deleted.
    </trashed-message>
    <announcement-preview :preview_message=form.reply />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" class="pr-6 pb-8 w-full" label="Reaction Name" />
          <div class="pr-6 pb-8 w-full">
            <label class="block text-gray-700">Triggers</label>
            <div class="mt-1 flex">
              <input v-model="newTrigger" @keydown.enter.prevent="addTrigger" type="text" class="form-input w-full" placeholder="Add trigger and press Enter" />
              <button type="button" class="ml-2 btn-indigo" @click="addTrigger">Add</button>
            </div>
            <div class="mt-2 flex flex-wrap">
              <span v-for="(t, i) in form.triggers" :key="i" class="inline-flex items-center bg-gray-200 text-sm rounded-full px-3 py-1 mr-2 mb-2">
                {{ t }}
                <button type="button" class="ml-2 text-red-500" @click="removeTrigger(i)">×</button>
              </span>
            </div>
          </div>
          <textarea-input v-model="form.reply" class="pr-6 pb-8 w-full" label="Reply" rows="4" max-rows="6"/>
          <text-input v-model="form.random" class="pr-6 pb-8 w-full lg:w-1/3" label="Random (integer)" data-toggle="tooltip" title="Trigger reaction only every n-th time." />
          <!--
          <text-input v-model="form.stream_title_hashtag" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Title Hashtags" />
          <text-input v-model="form.stream_tags" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Hash Tags" />
          <text-input v-model="form.stream_game" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Game" />
          -->
          <select-input v-model="form.mention_user" class="pr-6 pb-8 w-full lg:w-1/2" label="Mention User">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!reaction.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete reaction</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Reaction</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput.vue'
import AnnouncementPreview from '@/Shared/AnnouncementPreview.vue'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextareaInput,
    AnnouncementPreview,
  },
  layout: Layout,
  props: {
    reaction: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.reaction.name,
        triggers: (function() {
          const v = this.reaction.triggers
          if (Array.isArray(v)) return v.slice()
          if (!v) return []
          try {
            const parsed = JSON.parse(v)
            if (Array.isArray(parsed)) return parsed
          } catch (e) {
            // not JSON
          }
          return String(v).split(/[;,]+/).map(s => s.trim()).filter(Boolean)
        }).call(this),
        reply: this.reaction.reply,
        random: this.reaction.random || 0,
        mention_user: this.reaction.mention_user == true ? '1' : '0',
        is_enabled: this.reaction.is_enabled == true ? '1' : '0',
      }),
      newTrigger: '',
    }
  },

  methods: {
    addTrigger() {
      const t = (this.newTrigger || '').trim()
      if (!t) return
      if (!Array.isArray(this.form.triggers)) this.form.triggers = []
      if (!this.form.triggers.includes(t)) this.form.triggers.push(t)
      this.newTrigger = ''
    },
    removeTrigger(index) {
      this.form.triggers.splice(index, 1)
    },
    update() {
      // ensure triggers is an array
      if (!Array.isArray(this.form.triggers)) {
        try {
          this.form.triggers = JSON.parse(this.form.triggers)
        } catch (e) {
          this.form.triggers = String(this.form.triggers || '').split(/[;,]+/).map(s => s.trim()).filter(Boolean)
        }
      }
      this.form.put(this.route('reactions.update', this.reaction.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this reaction?')) {
        this.$inertia.delete(this.route('reactions.destroy', this.reaction.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this reaction?')) {
        this.$inertia.put(this.route('reactions.restore', this.reaction.id))
      }
    },
  },

}
</script>
